import type { IPlace } from "@bbj-types/address";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosStructurePartner } from "./axios";

export interface IFindStructurePartnersBody {
  filters?: {
    notDomiciled?: boolean;
    placeIds?: ObjectId[];
    displayPrivileged?: boolean;
    search?: string;
    tags?: string[];
  };
  skip: number;
  limit: number;
}

export type IFindStructurePartnersResponse = {
  total: number;
  data: {
    _id: ObjectId;
    name: string;
    place?: Pick<IPlace, "_id" | "placeLabel">;
    tags: string[];
    privileged: boolean;
    contactsCount: number;
    offersCount: number;
  }[];
  skip: number;
  limit: number;
  count: number;
};

export const useFindStructurePartners = () => {
  const [state, execute, cancel] = axiosStructurePartner<
    IFindStructurePartnersResponse,
    IFindStructurePartnersBody,
    unknown
  >(
    {
      url: "/find",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IFindStructurePartnersBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
